import Button from '@src/components/ui/atoms/button';
import Input from '@src/components/ui/atoms/input';
import placeApi from '@src/services/api/place';
import { PlaceInfoType } from '@src/types/place';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  padding: 50px 12px;
`;

const InputWrap = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  > div {
    width: 300px;
  }
`;

const InfoWrap = styled.div`
  width: 700px;
  margin-top: 100px;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px 20px;
  * {
    margin: 0;
  }
`;

// business_id VARCHAR(20) NOT NULL,
// 	business_name VARCHAR(30) NOT NULL,
// 	address_json TEXT,
// 	service_name VARCHAR(30) NOT NULL,
// 	start_time VARCHAR(6) NOT NULL,
// 	end_time VARCHAR(6) NOT NULL,
// 	business_type_id INT NOT NULL,
// 	refund_policy_id VARCHAR(10) NOT NULL,

export default function AddBookingPlace() {
  const navigate = useNavigate();
  const [url, setUrl] = useState('https://booking.naver.com/booking/10/bizes/210031');
  const [cookie, setCookie] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [placeData, setPlaceData] = useState<PlaceInfoType>();
  const getPlaceInfo = async () => {
    if (!url || !cookie) {
      return;
    }
    try {
      const { data } = await placeApi.getPlaceInfo(url, cookie);
      setPlaceData(data);
    } catch (error) {}
  };

  const handleSave = async () => {
    if (!placeData) {
      return;
    }
    if (!startTime || !endTime) {
      return;
    }
    const {
      id,
      name,
      addressJson,
      serviceName,
      businessTypeId,
      refundPolicy: { refundPolicyId },
      uncompletedBookingProcessCode,
      uncompletedBookingRefundRate,
    } = placeData;
    const { code } = await placeApi.saveBookingPlace({
      id,
      name,
      addressJson: JSON.stringify(addressJson),
      serviceName,
      businessTypeId,
      refundPolicyId,
      startTime,
      endTime,
      uncompletedBookingProcessCode,
      uncompletedBookingRefundRate,
    });
    if (code === 200) {
      navigate('/admin/booking-place-list');
    }
  };

  return (
    <Container>
      <InputWrap>
        <Input value={url} onChange={setUrl} />
        <Input value={cookie} onChange={setCookie} />
        <Button onClick={getPlaceInfo}>OK</Button>
      </InputWrap>
      <InfoWrap>
        <span>business_id</span>
        <span>{placeData?.id}</span>
        <span>business_name</span>
        <span>{placeData?.name}</span>
        <span>address_json</span>
        <span>{JSON.stringify(placeData?.addressJson)}</span>
        <span>service_name</span>
        <span>{placeData?.serviceName}</span>
        <span>business_type_id</span>
        <span>{placeData?.businessTypeId}</span>
        <span>business_name</span>
        <span>{placeData?.name}</span>
        <span>refund_policy_id</span>
        <span>{placeData?.refundPolicy.refundPolicyId}</span>
        <span>uncompleted_booking_refund_rate</span>
        <span>{placeData?.uncompletedBookingRefundRate}</span>
        <span>uncompleted_booking_process_code</span>
        <span>{placeData?.uncompletedBookingProcessCode}</span>
        <span>start time</span>
        <div>
          <Input value={startTime} onChange={setStartTime} />
        </div>
        <span>end time</span>
        <div>
          <Input value={endTime} onChange={setEndTime} />
        </div>
        <div></div>
        <div></div>
        <span>schedule start time</span>
        <p>
          {placeData?.placeScheduleJson.bizHours?.map(schedule => (
            <>
              {schedule.bizHourDay} : {schedule.bizHourStart} <br />
            </>
          ))}
        </p>
        <span>schedule end time</span>
        <p>
          {placeData?.placeScheduleJson.bizHours?.map(schedule => (
            <>
              {schedule.bizHourDay} : {schedule.bizHourEnd} <br />
            </>
          ))}
        </p>
      </InfoWrap>
      <div>
        <Button onClick={handleSave}>Save</Button>
      </div>
    </Container>
  );
}
